import React from 'react'
import './AddNoteButton.css'
import { TbPlus } from 'react-icons/tb'

export default function AddNoteButton({ onClick }) {
    return (
        <div onClick={onClick} className='add-note-button'>
            <TbPlus size={24} />
        </div>
    )
}
